
import React, {
  useEffect,
  useState,
} from "react";

import {
  loadAccessPolicy,
} from "./permissions";
import SystemTransition from "../components/SystemTransition";


export default function RbacProvider({
  children,
}) {

  const [ready, setReady] =
    useState(false);

  const [error, setError] =
    useState(null);


  useEffect(() => {

    let mounted = true;

    async function bootstrap() {

      try {

        await loadAccessPolicy();

      } catch (err) {

        console.error(
          "[RBAC] Error cargando politica central:",
          err
        );

        if (mounted) {
          setError(err);
        }

      } finally {

        if (mounted) {
          setReady(true);
        }
      }
    }

    bootstrap();

    return () => {
      mounted = false;
    };

  }, []);


  if (!ready) {
    return (
      <SystemTransition
  title="Preparando tu espacio de trabajo"
  subtitle="Aplicando tus permisos de acceso"
 />
    );
  }


  if (error) {

    console.warn(
      "[RBAC] API no disponible. Se aplicara politica default."
    );
  }


  return children;
}
